import { useQuery } from "@tanstack/react-query";
import axios from "../Axios";
import { Urls } from "../Urls";
import { decryptResponse } from "../Components/RateCard/utils";

/**
 * Fetches auction filter metadata from the API.
 * Accepts the same payload structure as auction list.
 * @param {string} transporter_id
 * @param {Object} filters
 */
const fetchMeta = async ({ queryKey }) => {
  const [, transporter_id, filters, bucket] = queryKey;

  const payload = {
    auction_status: bucket,
    ...(filters || {}),
  };

  const response = await axios.post(
    `${Urls.auctionBase}/filters?transporter_id=${transporter_id}&field=get_auction`,
    payload
  );
  const decrypted = decryptResponse(response?.data);

  // Exclude unwanted keys
  const { status, auction_id, ...filtered } = decrypted || {};

  return filtered;
};

/**
 * Hook to fetch auction filter metadata.
 * @param {string} transporter_id
 * @param {Object} filters - Same structure as auction list filters
 */
export const useAuctionFilterMeta = (bucket, transporter_id, filters = {}) =>
  useQuery({
    queryKey: ["auction-meta", transporter_id, filters, bucket],
    queryFn: fetchMeta,
    enabled: !!transporter_id, // don't run if transporter_id is missing
    staleTime: 10 * 60 * 1000,
  });
